/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import './table.scss';
import {
  useTable,
  usePagination,
  useSortBy,
  useGlobalFilter,
} from 'react-table';
import { ShortBothIcon, ShortDownIcon, ShortUpIcon } from '../icons/icons';
import { Refresh } from '../icons/comments-icon';

function DefaultCell({ value }) {
  return <span>{value ?? ''}</span>;
}

function BesicTable({
  columns,
  data,
  setSortColumnHeader,
  setSort,
  handleSortArrow,
  handleColumnHeader,
  noSpacing,
  pageSize,
  className,
}) {
  const enhancedColumns = useMemo(() => {
    return columns?.map((col) => {
      if (!col?.Cell && col?.accessor) {
        return {
          ...col,
          Cell: ({ row }) => {
            const value = row.original?.[col.accessor];
            return <DefaultCell value={value} />;
          },
        };
      }
      return col;
    });
  }, [columns]);

  const perPage = pageSize && pageSize > 0 ? pageSize : 10;
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } =
    useTable(
      {
        columns: enhancedColumns,
        data,
        getSubRows: (row) => row?.subRows || [],
        setSortColumnHeader,
        setSort,
        handleSortArrow,
        handleColumnHeader,
        initialState: {
          //  pageIndex: 0,
          // setSort: 0,
          // setSortColumnHeader: '',
          pageSize: perPage,
        },
      },
      useGlobalFilter,
      useSortBy,
      usePagination
    );

  // Render the UI for your table
  return (
    <div
      className={`custom-table-container ${
        noSpacing ? 'no-spacing' : ''
      } ${className}`}
    >
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => {
            return (
              <tr
                data-cy="table-head-row"
                {...headerGroup.getHeaderGroupProps()}
              >
                {headerGroup.headers.map((column) => (
                  <th
                    data-cy="tabel-head-data"
                    className={`
                      ${
                        column.render('Header') === 'Notification'
                          ? 'notification'
                          : ''
                      }
                        ${column.align}${
                      column.className ? ` ${column.className}` : ''
                    }
                    `}
                    style={{ width: column.setWidth, textAlign: column.align }}
                  >
                    <span>
                      {column.render('Header')}
                      {column.enableSortBy ? (
                        <span>
                          {handleSortArrow === 0 && (
                            <button
                              type="button"
                              tabIndex="0"
                              onClick={() => {
                                setSortColumnHeader(column.Header);
                                setSort(1);
                              }}
                            >
                              <ShortBothIcon color="#999999" />
                            </button>
                          )}
                          {handleSortArrow === 1 && (
                            <button
                              type="button"
                              tabIndex="0"
                              onClick={() => {
                                setSortColumnHeader(column.Header);
                                setSort(-1);
                              }}
                            >
                              {handleColumnHeader === column.Header ? (
                                <ShortDownIcon color="#999999" />
                              ) : (
                                <ShortBothIcon color="#999999" />
                              )}
                            </button>
                          )}
                          {handleSortArrow === -1 && (
                            <button
                              type="button"
                              tabIndex="0"
                              onClick={() => {
                                setSortColumnHeader(column.Header);
                                setSort(1);
                              }}
                            >
                              {handleColumnHeader === column.Header ? (
                                <ShortUpIcon color="#999999" />
                              ) : (
                                <ShortBothIcon color="#999999" />
                              )}
                            </button>
                          )}
                          {column.refresh && (
                            <button type="button" tabIndex="0">
                              <Refresh size="0.764vw" color="#0088FA" />
                            </button>
                          )}
                        </span>
                      ) : null}
                    </span>
                  </th>
                ))}
              </tr>
            );
          })}
        </thead>
        <tbody data-cy="tabel-body-data" {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr
                data-cy="tabel-body-row"
                {...row.getRowProps()}
                className={row.original.isDeleted ? ' disabled' : ''}
              >
                {row.cells.map((cell) => (
                  <td
                    {...cell.getCellProps()}
                    align={`
                      ${
                        cell.render('Header') === 'Notification' ? 'center' : ''
                      }
                      ${cell.column.align}
                      
                    `}
                    style={{
                      textAlign: cell.column.align,
                      width: cell.column.setWidth,
                    }}
                  >
                    {cell.render('Cell')}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default BesicTable;
